import { Grid } from "@material-ui/core";
import React from "react";

import ReportCard from "./ReportCard";

/**
 * ReportPageコンポーネント.
 *
 * @return {object} コンポーネント
 */
function ReportPage() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ReportCard />
      </Grid>
    </Grid>
  );
}

export default ReportPage;
